var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.clickHandler}},[_c('v-icon',{attrs:{"size":"21"}},[_vm._v("mdi-open-in-new")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }